import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import Navigation from '../Navigation/Desktop';
import MobileNavigation from '../Navigation/Mobile';
import SocialLinks from '../SocialLinks';

const Header = ({ pathname }) => {
  return (
    <header className="site-header">
      <div className="logo">
        <Logo />
      </div>

      <div className="content">
        <div className="tools-wrapper">
          <SocialLinks />
          <MobileNavigation pathname={pathname} />
        </div>
        <div className="nav-wrapper">
          <Navigation pathname={pathname} />
          <div className="search">
            <SearchWidget />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
